import * as Scrivito from "scrivito";
import defaultPageAttributes from "objs/_defaultPageAttributes";
import metadataAttributes from "objs/_metadataAttributes";

const ProjectItem = Scrivito.provideObjClass("ProjectItem", {
  attributes: {
    ...defaultPageAttributes,
    ...metadataAttributes,
    redirectToProjectConfigurator: [
      "reference",
      { only: "ProjectConfigurator" },
    ],
    redirectAfterDelete: ["reference", { only: "ProjectList" }],
  },
  extractTextAttributes: ["title", "subtitle"],
});

export default ProjectItem;
